import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function animation_sub() {
  let mm = gsap.matchMedia();

  // =============================================================================
  // コンテンツスライドアップ
  // =============================================================================
  gsap.set(".js-fadeup", {
    opacity: 0,
    yPercent: 30,
  });
  gsap.utils.toArray(".js-fadeup").forEach((targetfadeup) => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: targetfadeup, //アニメーションが始まるトリガーとなる要素。
          start: "top 80%",
          toggleAction: "play none none none",
        },
      })

      .to(targetfadeup, {
        opacity: 1,
        yPercent: 0,
        duration: 1,
        ease: "power4.out",
      });
  });

  mm.add("(max-width: 767px)", () => {
    gsap.utils.toArray(".js-fadeup").forEach((targetfadeup) => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: targetfadeup, //アニメーションが始まるトリガーとなる要素。
            start: "top%",
            toggleAction: "play none none none",
          },
        })
  
        .to(targetfadeup, {
          opacity: 1,
          yPercent: 0,
          duration: 1,
          ease: "power4.out",
        });
    });
  });

}